import React from 'react'

import { MonthlyRetirementBudget } from '@components/MonthlyRetirementBudget'
import { ParticipantFilter } from './ParticipantFilter'

export const JointMonthlyRetirementBudget = ({ participantsQueries, jointBudget }) => {
  const [selectedParticipantId, setSelectedParticipantId] = React.useState('both')
  const selectedParticipantQuery = participantsQueries.find((participantQuery) => participantQuery.participant.id === selectedParticipantId)

  const baseScenarioProps = selectedParticipantQuery
    ? {
      desiredRetirementIncome: selectedParticipantQuery?.forecast.data.baseScenario.budget.desiredRetirementIncome,
      actualRetirementIncome: selectedParticipantQuery?.forecast.data.baseScenario.budget.maximumSafeRetirementIncome
    }
    : {
      desiredRetirementIncome: jointBudget.net_monthly_retirement_budget_real,
      actualRetirementIncome: participantsQueries.reduce((sum, participantQuery) => sum + participantQuery.forecast.data.baseScenario.budget.maximumSafeRetirementIncome, 0)
    }

  return (
    <>
      <MonthlyRetirementBudget
        filter={() => (
          <ParticipantFilter
            showBoth
            filteredItemsName={'retirement budget'}
            participantsQueries={participantsQueries}
            selectedParticipantId={selectedParticipantId}
            setSelectedParticipantId={setSelectedParticipantId}
          />
        )}
        style={{ height: '100%', minHeight: '25rem' }}
        budgetType={jointBudget.selected_budget_type}
        baseScenario={baseScenarioProps}
      />
    </>
  )
}
